// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"229d2601","58":"2f28c50e","453":"89d48eb7","688":"5ad5be45","961":"020d5ed5","987":"3f52f275"}[chunkId] + ".chunk.js";
};